<template lang="pug">
.substrate(@click="close")
  .substrate__popup-change-pass(@click.stop="" :class="innerClass")
    slot
    button.substrate__popup-change-pass__exit(@click.prevent="close")

</template>

<script>
import CustomMountMixin from '../../../components/_mixins/custom-mount'

export default {
  name: 'substrate',
  mixins: [CustomMountMixin],
  props: {
    innerClass: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      MOUNT_TARGET: this.$$s('globalModal.appendTo.target'),
      MOUNT_CONTAINER: this.$$s(
        'globalModal.appendTo.container',
        '.rocket-effect-container.rocketeffect-global-modal-container.supercharged-entertainment-container'
      ),
      MOUNT_CONTAINER_CLASSES: this.$$s(
        'globalModal.appendTo.classes',
        'rocket-effect-container rocketeffect-global-modal-container supercharged-entertainment-container'
      ),
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>
